<template>
  <div class="usuarios-container">
    <h1 class="titulo">Lista de Usuarios Medicinales</h1>
    <input type="text" v-model="terminoBusqueda" placeholder="Buscar por nombre, email o identificación" class="campo-busqueda" />
    <ul class="lista-usuarios">
      <li v-for="usuario in usuariosFiltrados" :key="usuario.id" class="usuario-item">
        <span>{{ usuario.nombre }} {{ usuario.apellido }} - {{ usuario.email }} - {{ usuario.identificacion }}</span>
        <div class="botones-acciones">
          <button class="btn-detalles" @click="verDetalles(usuario)"><font-awesome-icon :icon="['fas', 'info-circle']" /> Detalles</button>
          <button class="btn-editar" @click="editarUsuario(usuario)"><font-awesome-icon :icon="['fas', 'edit']" /> Editar</button>
        </div>
      </li>
    </ul>
    <div class="paginacion">
      <button @click="paginaActual--" :disabled="paginaActual === 1"><font-awesome-icon :icon="['fas', 'arrow-left']" /> Anterior</button>
      <span>Página {{ paginaActual }} de {{ totalPaginas }}</span>
      <button @click="paginaActual++" :disabled="paginaActual === totalPaginas">Siguiente <font-awesome-icon :icon="['fas', 'arrow-right']" /></button>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue';
import axios from '@/axios';
import { useStore } from 'vuex';

export default {
 
  setup(props, { emit }) {
    const usuarios = ref([]);
    const paginaActual = ref(1);
    const usuariosPorPagina = 10;
    const terminoBusqueda = ref('');
    const store = useStore();
    const clubActual = store.getters.getClubActual;

    const fetchUsuarios = async () => {
      try {

        const response = await axios.get('/api/usuario-medicinal', {
          params: {
            club_id: clubActual.id
          }
        });
        usuarios.value = response.data;
      } catch (error) {
        console.error('Error al obtener usuarios medicinales:', error);
      }
    };

    const usuariosFiltrados = computed(() => {
      return usuarios.value.filter(usuario => {
        const termino = terminoBusqueda.value.toLowerCase();
        return (
          (usuario.nombre || '').toLowerCase().includes(termino) ||
          (usuario.apellido || '').toLowerCase().includes(termino) ||
          (usuario.email || '').toLowerCase().includes(termino) ||
          (usuario.identificacion || '').toLowerCase().includes(termino)
        );
      });
    });

    const paginatedUsuarios = computed(() => {
      const start = (paginaActual.value - 1) * usuariosPorPagina;
      const end = start + usuariosPorPagina;
      return usuariosFiltrados.value.slice(start, end);
    });

    const totalPaginas = computed(() => {
      return Math.ceil(usuariosFiltrados.value.length / usuariosPorPagina);
    });

    const verDetalles = (usuario) => {
      emit('verDetalles', usuario);
    };

    const editarUsuario = (usuario) => {
      emit('editar', usuario);
    };

    onMounted(() => {
      fetchUsuarios();
    });

    return {
      usuarios,
      usuariosFiltrados,
      paginatedUsuarios,
      paginaActual,
      totalPaginas,
      verDetalles,
      editarUsuario,
      terminoBusqueda,
      clubActual
    };
  }
};
</script>

<style scoped>
.usuarios-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.titulo {
  text-align: center;
  font-size: 24px;
  margin-bottom: 20px;
  color: #333;
}

.campo-busqueda {
  width: 100%;
  padding: 10px;
  margin-bottom: 20px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
}

.lista-usuarios {
  list-style-type: none;
  padding: 0;
}

.usuario-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #ddd;
}

.botones-acciones {
  display: flex;
  gap: 10px;
}

.btn-detalles, .btn-editar {
  padding: 5px 10px;
  font-size: 14px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.btn-detalles {
  background-color: #4a7d3a;
  color: white;
}

.btn-detalles:hover {
  background-color: #3b6230;
}

.btn-editar {
  background-color: #4fbfbe;
  color: white;
}

.btn-editar:hover {
  background-color: #3f9999;
}

.paginacion {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.paginacion button {
  padding: 5px 10px;
  margin: 0 5px;
  font-size: 14px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.paginacion button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.paginacion span {
  font-size: 14px;
}
</style> 